import React, { useEffect, useState } from "react";
import { Select, Card, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getFilterInfo, selectFilterInfo } from "../../../routes/Chat/chat.ducks";
import styles from "../chatPage.scss"
import MobileDropdownSelect from "../../../components/FormControls/DropdownSelect/MobileDropdownSelect";
import { CHAT_LIST_OPTIONS } from "../constants/constants";
import { FilterIcon } from "./FilterIcon";
import Skeleton from "../../../components/Skeleton";

type Props = {
  isMobile: boolean;
  onUserFilterChange: (userId: any) => void;
  onAdFilterChange: (adId: any) => void;
  onInboxFilterChange: (inboxType: any) => void;
  userParam?: string;
  adParam?: string;
  inboxTypeParam?: number;
}

export const FiltersCard = ({
  onAdFilterChange,
  onUserFilterChange,
  onInboxFilterChange,
  isMobile,
  userParam,
  adParam,
  inboxTypeParam,
}: Props) => {
  const dispatch = useDispatch()
  const filterInfo = useSelector(selectFilterInfo)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    dispatch(getFilterInfo(
      () => setIsLoading(false)
    ))
  }, [])


  if (isLoading) {
    return (
      <Card style={{ marginBottom: 20, boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.05)", borderRadius: 6 }} bordered={false}>
        <div className={styles.filtersCard}>
          <Skeleton style={{ height: 54, width: "50%" }} />
          <Skeleton style={{ height: 54, width: "50%" }} />
        </div>
      </Card>
    )
  }
  if (!filterInfo || !(filterInfo && filterInfo.users)) return null;

  const userOptions = [
    // { value: null, title: "Korisnik" },
    ...filterInfo.users.map(user => ({ value: user.id, title: user.name }))
  ]

  const adOptions = [
    // { value: null, title: "Oglas" },
    ...filterInfo.adTitles.map(adTitle => ({ value: adTitle.id, title: adTitle.name }))

  ]

  return (
    <Card style={{ marginBottom: 20, boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.05)", borderRadius: 6 }} bordered={false}>
      <div className={styles.filtersCard}>

        {isMobile ? (
          <React.Fragment>
            <MobileDropdownSelect
              options={userOptions}
              value={userParam}
              onChange={onUserFilterChange}
              placeholder="Korisnik"
              allowClear
              title="Filtriraj"
            />
            <MobileDropdownSelect
              options={adOptions}
              value={adParam}
              onChange={onAdFilterChange}
              placeholder="Oglas"
              allowClear
              title="Filtriraj"
            />
            <MobileDropdownSelect
              options={CHAT_LIST_OPTIONS}
              value={inboxTypeParam}
              onChange={onInboxFilterChange}
              allowClear
              title="Filtriraj"
              render={(
                <Button className={styles.filtersButton} type={inboxTypeParam ? "primary" : "default"}>
                  <FilterIcon color={inboxTypeParam ? "default" : "primary"} />
                </Button>
              )}
            />
          </React.Fragment>

        ) : (
          <React.Fragment>
            <Select
              onChange={onUserFilterChange}
              placeholder="Korisnik"
              value={userParam}
              style={{ flex: 1, maxWidth: "50%" }}
              className={styles.filtersSelect}
            >
              {userParam && <Select.Option value={null}>Poništi</Select.Option>}
              {userOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>{option.title}</Select.Option>
              ))}
            </Select>
            <Select
              onChange={onAdFilterChange}
              placeholder="Oglas"
              value={adParam}
              style={{ flex: 1, maxWidth: "50%" }}
              className={styles.filtersSelect}
            >
              {adParam && <Select.Option value={null}>Poništi</Select.Option>}
              {adOptions.map(adTitle => (
                <Select.Option key={adTitle.value} value={adTitle.value}>{adTitle.title}</Select.Option>
              ))}
            </Select>
          </React.Fragment>

        )}
      </div>

    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/ChatsList/FiltersCard.tsx